import { UploadDialogAction } from '../upload-dialog-actions.enum';

export const DIALOG_ACTIONS_CONFIG = {
  continuedStay: {
    label: UploadDialogAction.ContinuedStay,
    disabled: false,
  },
  level: {
    label: UploadDialogAction.Level,
    disabled: false,
  },
  withoutRequest: {
    label: UploadDialogAction.WithoutRequest,
    disabled: false,
  },
};